'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M896 448c0-6.26-0.152-12.59-0.454-18.812-1.278-26.478-23.746-46.918-50.256-45.632-26.478 1.278-46.908 23.778-45.63 50.256 0.224 4.688 0.34 9.46 0.34 14.186 0 158.894-129.196 288.166-288 288.166s-288-129.272-288-288.166c0-4.692 0.114-9.438 0.336-14.106 1.27-26.48-19.166-48.974-45.644-50.246-26.46-1.26-48.974 19.166-50.244 45.646-0.298 6.196-0.448 12.49-0.448 18.708 0 190.018 138.622 348.226 320 378.8v133.2c0 35.346 28.654 64 64 64s64-28.654 64-64v-133.2c181.378-30.574 320-188.782 320-378.8z' }),
        React.createElement('path', { d: 'M512 0c-106.040 0-192 85.96-192 192v256c0 106.040 85.96 192 192 192s192-85.96 192-192v-256c0-106.040-85.96-192-192-192z' })
    ));
};